import { render } from "./LexiconCard.vue?vue&type=template&id=4c770f88&scoped=true&ts=true"
import script from "./LexiconCard.vue?vue&type=script&lang=ts"
export * from "./LexiconCard.vue?vue&type=script&lang=ts"

import "./LexiconCard.vue?vue&type=style&index=0&id=4c770f88&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c770f88"]])

export default __exports__